/**
 * recruit-jobs.js — 求人一覧の検討支援。
 * 気になる求人は個人情報を送信せず、このブラウザの localStorage だけに保存する。
 */
(function () {
  'use strict';

  var root = document.querySelector('.recruit-jobs');
  if (!root) return;

  var storageKey = 'gakumon-recruit-saved-v1';
  var cards = Array.from(root.querySelectorAll('[data-recruit-job-card]'));
  var saveButtons = Array.from(root.querySelectorAll('[data-recruit-save]'));
  var filterButton = root.querySelector('[data-recruit-saved-filter]');
  var savedCount = root.querySelector('[data-recruit-saved-count]');
  var visibleCount = root.querySelector('[data-recruit-visible-count]');
  var empty = root.querySelector('[data-recruit-saved-empty]');
  var showAll = root.querySelector('[data-recruit-show-all]');
  var status = root.querySelector('[data-recruit-status]');
  var resultTitle = root.querySelector('.recruit-jobs__result-head h2');
  var filterDetails = root.querySelector('[data-recruit-filter-details]');
  var savedOnly = false;
  var defaultResultTitle = resultTitle ? resultTitle.textContent : '募集一覧';

  if (filterDetails && window.matchMedia('(max-width: 767px)').matches && filterDetails.dataset.hasSelection !== '1') {
    filterDetails.removeAttribute('open');
  }

  var readSaved = function () {
    try {
      var value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return new Set(Array.isArray(value) ? value.map(String) : []);
    } catch {
      return new Set();
    }
  };

  var saved = readSaved();

  var writeSaved = function () {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(Array.from(saved)));
    } catch {
      // 保存できない環境でも閲覧・応募は継続できる。
    }
  };

  var setButtonState = function (button) {
    var card = button.closest('[data-recruit-job-card]');
    var active = card && saved.has(card.dataset.jobId);
    button.classList.toggle('is-saved', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var icon = button.querySelector('span');
    var label = button.querySelector('b');
    if (icon) icon.textContent = active ? '♥' : '♡';
    if (label) label.textContent = active ? '保存済み' : '気になる';
  };

  var render = function (message) {
    var visible = 0;
    cards.forEach(function (card) {
      var shouldShow = !savedOnly || saved.has(card.dataset.jobId);
      card.hidden = !shouldShow;
      if (shouldShow) visible += 1;
    });
    saveButtons.forEach(setButtonState);

    if (savedCount) savedCount.textContent = String(saved.size);
    if (filterButton) {
      filterButton.hidden = saved.size === 0;
      filterButton.disabled = saved.size === 0;
      filterButton.classList.toggle('is-active', savedOnly);
      filterButton.setAttribute('aria-pressed', savedOnly ? 'true' : 'false');
    }
    if (visibleCount) visibleCount.textContent = String(visible);
    if (empty) empty.hidden = !savedOnly || visible > 0;
    root.classList.toggle('is-saved-only', savedOnly);
    if (resultTitle) resultTitle.textContent = savedOnly ? '保存した求人' : defaultResultTitle;
    if (status && message) status.textContent = message;
  };

  saveButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var card = button.closest('[data-recruit-job-card]');
      if (!card) return;
      var id = card.dataset.jobId;
      if (saved.has(id)) {
        saved.delete(id);
        render('気になる求人から削除しました。');
      } else {
        saved.add(id);
        render('気になる求人に保存しました。');
      }
      writeSaved();
    });
  });

  if (filterButton) {
    filterButton.addEventListener('click', function () {
      savedOnly = !savedOnly;
      render(savedOnly ? '保存した求人だけを表示しています。' : 'すべての求人を表示しています。');
    });
  }

  if (showAll) {
    showAll.addEventListener('click', function () {
      savedOnly = false;
      render('すべての求人を表示しています。');
    });
  }

  render();
}());
